/* RESPONSIBLE TEAM: team-ai-agent */
export const contentWrapperTypes = {
  answers: 4,
};
